<template>
<div>
  <FileBrowser 
    v-if="openFileBrowser" 
    :selected.sync="selectedFile" 
    :mode="mode" 
    :isSuper="isSuper"
    :show.sync="openFileBrowser"
    @update:save="saveToServer"
  />
  <v-card text style="min-height: 100%; width: 100%; height: 100%">
    <v-card-actions>
      <div>
        <v-row>
        <v-row align="center" :style="{border: '1px solid', marginLeft: '5px', padding: '3px'}">
        Open From:
        <v-btn
          color="blue darken-1"
          text
          @click.native="openFileBrowser = !openFileBrowser; mode='read'"
          >Server
          <v-icon style="padding-left: 12px" left color="green"
            >mdi-file</v-icon>
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click.native="tableLoading = !tableLoading;"
          >Database
          <v-icon style="padding-left: 12px" left color="green"
            >mdi-file</v-icon>
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click.native="loading = !loading;"
          >Local File
          <v-icon style="padding-left: 12px" left color="green"
            >mdi-file</v-icon>
        </v-btn>
        </v-row>
        <!-- <v-spacer></v-spacer> -->
        <v-row align="center" :style="{border: '1px solid', marginLeft: '15px', padding: '3px'}">
        Save To:
        <v-btn
          color="blue darken-1"
          text
          @click.native="openFileBrowser = !openFileBrowser; mode='write'"
          >Server
          <v-icon style="padding-left: 12px" left color="green"
            >mdi-content-save
          </v-icon>
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click.native="tableSaving = !tableSaving;"
          >Database
          <v-icon style="padding-left: 12px" left color="green"
            >mdi-content-save
          </v-icon>
        </v-btn>
        <v-label v-if ="loading" class="text-reader"
          color="blue darken-1"
          text>
          <input type="file" @change="loadTextFromFile">
        </v-label>
        <v-btn
          color="blue darken-1"
          text
          @click.native="saving = !saving;"
          >Local File
          <v-icon style="padding-left: 12px" left color="green"
            >mdi-content-save
          </v-icon>
        </v-btn>
        </v-row>
        <v-row align="center" :style="{border: '1px solid', marginLeft: '15px', padding: '3px'}">
          <v-btn color="blue darken-1" @click="newFile">New File</v-btn>
        </v-row>
        </v-row>
      </div>
    </v-card-actions>
    <h3 style="fontsize: 1.1rem; text-align: center; padding-top: 5px;">{{ filename }}<span :style="{color: 'red'}" v-if="status != ''"> ({{status}})</span></h3>
    <div v-if="saving && !loading" class="filebox">
      <v-row style="margin: 10px; margin-right: 50px;">
          <v-text-field  style="margin-right: 50px;" v-model="savefilename" label="File Name" hide-details clearable single-line></v-text-field>
          <v-btn style="margin-top: 10px;" dark color="green" @click="saveFile"> SAVE </v-btn>
      </v-row>
    </div>
    <div v-if="tableLoading && !saving" class="filebox">
      <v-row style="margin: 10px; margin-right: 50px;">
          <v-select  
            style="margin-right: 50px;" 
            :items="tableFiles"
            v-model="tableFile"></v-select>
          <v-btn :disabled="!tableFile" style="margin-top: 10px;" dark color="green" @click="loadDBFile"> Load </v-btn>
      </v-row>
    </div>
    <div v-if="tableSaving && !tableLoading" class="filebox">
      <v-row style="margin: 10px; margin-right: 50px;">
          <v-text-field  style="margin-right: 50px;" v-model="loadedTableFileName" label="Name in Table" hide-details clearable single-line></v-text-field>
          <v-btn style="margin-top: 10px;" dark color="green" @click="saveDBFile"> SAVE </v-btn>
      </v-row>
    </div>
    <Editor :style="{margin: '2px'}" @update="updateContent" :loadedContent="newContent"/>

  </v-card>
  </div>
</template>
<script>
import axiosInstances from "@/../../coreui/server/axiosInstances";
// import DND from "@/../../coreui/library/DragAndDrop";
import Editor from "./Editor";
import { sync } from "vuex-pathify";
// import FileSelector from './FileSelector';
import FileBrowser from '../../library/FileBrowser.vue'
export default {
  props: ['isSuper'],
  components: {
    // DND,
    Editor,
    // FileSelector,
    FileBrowser
  },
  data: () => ({
    status: '',
    mode: 'read',
    openFileBrowser: false,
    selectedFile: null,
    selIsDir: false,
    tableFiles: [],
    savefilename: '',
    newContent: 'Edit your content here',
    content: 'Edit your content here',
    unsavedContent: '',
    saving: false,
    loading: false,
    tableSaving: false,
    tableLoading: false,
    tableFile: null,
    filename: "New File",
    sendMQTT: false,
    removeFile: null,
    url: null,
    subdir: null,
    files: [],
    currentFiles: [],
    newContentLoaded: false,
    form: [
      { key: "org", label: "Org", value: null },
      { key: "subdir", label: "Directory", value: null },
      { key: "fname", label: "File", value: null, hide: false },
    ],
    mqtt: [
      { key: "topic", label: "Topic", value: null },
      { key: "msg", label: "Message", value: {} },
    ],
    temp: [
      { key: "table", label: "Table", value: null },
      { key: "payload", label: "Payload", value: "nothing" },
    ],
  }),
  computed: {
    user: sync('login/loggedinUser'),
  },
  watch : {
    async selectedFile (val) {
      console.log(val)
      // return
      if (val.node.ext != 'html') {
        this.$root.$confirm(
          'Error', 
          'Only html files are currently supported for editing', 
          {nocancel: true, ok: 'OK', color: 'red'})
          .then(function(confirm) {
          }
        )
      } else {
        let self = this
        setTimeout(async function() {
          console.log(val, val.folder, val.root.length)
          let subdir = val.folder //val.folder.substr(val.root.length)
          console.log(subdir)
          let url = val.url + val.file + (subdir != '' ? ('?subdir=' + subdir) : '' )
          console.log('HTML Editor: 184- selectedFile watch:',url)
          // return
          let res = await axiosInstances.fileServer.get(url)
          self.newContent = res.data
          if (val.file) self.filename = val.file
          self.status = ''
          self.openFileBrowser = false
        },1000)
      }
    },

    tableSaving (val) {
      if (val) {
        this.loading = false
        this.saving = false
        this.tableLoading = false
      }
    },

    tableLoading (val) {
      if (val) {
        this.loading = false
        this.tablesaving = false
        this.saving = false
      }
    },

    loading (val) {
      if (val) {
        this.tableLoading = false
        this.tablesaving = false
        this.saving = false
      }
    },

    saving (val) {
      if (val) {
        this.loading = false
        this.tablesaving = false
        this.tableLoading = false
      }
    },

    newContent (val) {
      this.unsavedContent = val
    }
  },
  methods: {
    newFile() {
      var self = this
      if (this.status == 'unsaved') {
        this.$root.$confirm('Discard Edits?', 'You have unsaved content. Clear it?', { color: 'red' })
        .then((confirm) => {
          if (confirm) {
            self.newContent = 'Edit here...'
            self.status = ''
            self.newContentLoaded = true
            this.filename = 'New File'
          }
        }) 
      } else {
        self.newContent = 'Edit here...'
        self.status = ''
        self.newContentLoaded = true
        this.filename = 'New File'
      }
      
    },
    async saveToServer(arg) {
      console.log(arg)
      // return
      let formData = new FormData()
      let data = `
<!DOCTYPE html>
<html lang=en">
<head><meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Entrinsia document</title>
  <style>
        /* For phone screens */
        @media (max-width: 600px) {
            img {
                width: 100%; /* Resize to fit the container */
            }
        }

        /* For tablet screens */
        @media (min-width: 601px) and (max-width: 1024px) {
            img {
                width: 80%; /* Resize to 50% of the container's width */
            }
        }

        /* Default size for larger screens (e.g., desktop) */
        img {
            /* No width property specified, image will retain its original size */
        }
    </style>
</head>
<body>
` + this.unsavedContent + 
`
</body>
</html>
`
      formData.append('file', new Blob([data], {
        type: "text/plain"
      }))
      let url = arg.basePutURL +'?rename=' + arg.file +
        ((arg.folder == '' || arg.folder == '/' || arg.folder == null ) ? '' :  '&subdir='+
        arg.folder)
      console.log('HTML Editor: 275- uploading dnd file:',url)
      // return
      let res = await axiosInstances.fileServer.post(url, formData, {
          headers: {
            'Content-Type': `multipart/form-data;`
          },
        }
      )
      this.status = ''
      this.newContentLoaded = true
      this.openFileBrowser = false
    },
    saveFile() {
      if (this.savefilename == null || this.savefilename == '') {
        this.saving = false
        return
      }
      const a = document.createElement("a");
      a.href = URL.createObjectURL(new Blob([this.unsavedContent], {
        type: "text/plain"
      }));
      a.setAttribute("download", this.savefilename);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      this.saving = false
      this.status = ''
      this.filename = this.savefilename
    },
    updateContent (val) {
      this.unsavedContent = val
      if (!this.newContentLoaded) {
        // this.unsavedContent = val
        this.status = "unsaved"
      } else {
        this.status = ''
        this.newContentLoaded = false
      }
    },
    loadTextFromFile(ev) {
      const file = ev.target.files[0];
      this.filename = file.name
      const reader = new FileReader();
      reader.onload = e => {
        this.newContent = e.target.result
        this.loading = false
      }
      reader.readAsText(file);
      this.savefilename = this.filename
      this.status = ''
      this.newContentLoaded = true
    },
    loadFile (val) {
      this.newContent = val
    },
    async getTableFiles() {
      let f = await axiosInstances.apiServer.get('/dt/v1/crm_comms?return=name')
      if (f != null && f.data != null) {
        let names = []
        f.data.forEach((i) => {
          names.push(i.name)
        })
        this.tableFiles = names
      }
    },
    async loadDBFile() {
      let f = await axiosInstances.apiServer.get('/dt/v1/crm_comms?name='
      +this.tableFile+'&return=value')
      if (f != null && f.data != null && f.data.length != 0) {
        this.newContent = f.data[0]['value']
      }
      this.loadedTableFileName = this.tableFile
      this.tableLoading = false
    },
    async saveDBFile() {
      let f = await axiosInstances.apiServer.get('/dt/v1/crm_comms?name='
      + this.loadedTableFileName)
      if (f == null || f.data == null) {
        await axiosInstances.apiServer.post('/dt/v1/crm_comms',
            {'name': this.loadedTableFileName, 'value': this.unsavedContent})
        this.getTableFiles()
      } else {
        let id = f.data[0]['_id']
        var self = this
        this.$root.$confirm("Overwrite?", 'Name exists, do you want to overwrite content?', {color: 'red'}).then(async function(confirm) {
          if (confirm) {
            await axiosInstances.apiServer.patch('/dt/v1/crm_comms/'+id,
            {'value': self.unsavedContent})
            self.tableSaving = false
          } else {
            self.tableSaving = false
          }
        })
      }
      
    }
    // async openF(val) {
    //   let fsub = val.dir != null && val.dir != ""
    //       ? val.file + `?subdir=${val.dir}`
    //       : val.file 
    //   let url = "/getfiles/" + val.org + "/" + fsub
    //   let f = await axiosInstances.apiServer.get(url)
    //   if (f != null && f.data != null) {
    //     this.content = f.data
    //     console.log(f.data)
    //   }
    // },
    // async saveF(val) {
    //   console.log(this.newContent)
    //   let fsub = val.dir != null && val.dir != ""
    //       ? val.file + `?subdir=${val.dir}`
    //       : val.file 
    //   let url = "/files/" + val.org + "/" + fsub
    //   console.log("*****URL*******", url)
    //   formData = new FormData()
    //   formData.append(val.file, this.newContent)
    //   axiosInstances.apiServer.post(this.url , formData, {
    //     headers: {
    //       'Content-Type': 'multipart/form-data'
    //     },
    //   })
    // },

    // async deleteFile(f) {
    //   console.log(`deleting file ${this.removeFile}`);
    //   try {
    //     let res = await axiosInstances.apiServer.delete(
    //       "/getfiles/" +
    //         this.form[0].value +
    //         "/" +
    //         this.removeFile +
    //         this.subdir
    //     );
    //     console.log("res = ", res);
    //     this.currentFiles = res.data;
    //   } catch (ex) {
    //     this.currentFiles = [];
    //   }
    //   await this.refreshDir();
    // },
    // async refreshDir() {
    //   this.subdir =
    //     this.form[1].value != null && this.form[1].value != ""
    //       ? `?subdir=${this.form[1].value}`
    //       : "";
    //   this.url = this.form[0].value + this.subdir;
    //   console.log("URL: ", this.url);
    //   this.removeFile = null;
    //   try {
    //     let res = await axiosInstances.apiServer.get(
    //       "/getfiles/" + this.form[0].value + "/" + this.subdir
    //     );
    //     console.log("res = ", res);
    //     this.currentFiles = res.data;
    //   } catch (ex) {
    //     this.currentFiles = [];
    //   }
    //   if (this.currentFiles == null) {
    //     this.currentFiles = [];
    //   }
    // },
  },
  mounted() {
    this.getTableFiles()
  },
};
</script>
<style lang="sass">
// @import './sass/main.scss'
</style>

<style lang="scss">
// #ed {
//   // display: flex;
//   padding-top: 10px;
//   box-sizing: border-box;
//   flex-flow: column;
//   align-items: center;
//   font-family: -apple-system, "Noto Sans", "Helvetica Neue", Helvetica,
//     "Nimbus Sans L", Arial, "Liberation Sans", "PingFang SC", "Hiragino Sans GB",
//     "Noto Sans CJK SC", "Source Han Sans SC", "Source Han Sans CN",
//     "Microsoft YaHei", "Wenquanyi Micro Hei", "WenQuanYi Zen Hei", "ST Heiti",
//     SimHei, "WenQuanYi Zen Hei Sharp", sans-serif;
// }
</style>

<style scoped>
/* .text-reader {
  position: relative;
  overflow: hidden;
  display: inline-block;

  border: 2px solid;
  border-radius: 5px;
  padding: 8px 12px;
  cursor: pointer;
}
.text-reader input {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  opacity: 0;
}
.filebox {
  background-color: beige;

  margin: 20px;
  padding: 10px;
  border: 1px solid grey;
  border-radius: 15px;
} */
</style>


